import { render, staticRenderFns } from "./UButton.vue?vue&type=template&id=561baca2&scoped=true&"
import script from "./UButton.vue?vue&type=script&lang=js&"
export * from "./UButton.vue?vue&type=script&lang=js&"
import style0 from "./UButton.vue?vue&type=style&index=0&id=561baca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561baca2",
  null
  
)

export default component.exports